import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { isPossiblePhoneNumber } from 'react-phone-number-input';
import PhoneInputWithCountry from 'react-phone-number-input/react-hook-form';

import { editPartner, fetchPartnerById } from '../../services/partner.service';
import AppModal from '../appModal.component';
import MessageContainer from '../message.component';
import WithLogin from '../withLogin.component';

const EditPartner = props => {
    const id = props.selectedRow.id;
    const [show, setModalShow] = useState(props.open);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({});

    const handleModalClose = () => {
        setModalShow(false);
        props.setEditForm(false);
        props.reloadDataTable(1);
    };

    const getPartner = async () => {
        try {
            const resp = await fetchPartnerById(id);
            Object.keys(resp).forEach(key => {
                setValue(key, resp[key]);
            });

        } catch (error) {
            if (
                error.response.status === 400 ||
                error.response.status === 404
            ) {
                setMessage({
                    type: 'Error',
                    message: `${error.response.data.detail}`,
                });
            }
        }
    };

    useEffect(() => {
        getPartner()
        setModalShow(props.open);
        setMessage({});
    }, [props]); // eslint-disable-line react-hooks/exhaustive-deps

    const {
        control,
        reset,
        register,
        handleSubmit,
        setError,
        setValue,
        formState: { errors },
    } = useForm({
        defaultValues: {
            name: '',
            contact_name: '',
            contact_email: '',
            contact_number: '',
            subdomain: '',
        },
    });

    const handleCreatePartner = async data => {
        setLoading(true);
        try {
            setMessage({});
            await editPartner(id, data);
            setMessage({
                type: 'Success',
                message: 'Partner has been updated successfully',
            });
            reset();
        } catch (error) {
            if (error.response.status === 400) {
                setMessage({
                    type: 'Error',
                    message: `${error.response.data.detail}`,
                });
                error.response.data.errors?.forEach(validationError => {
                    Object.keys(validationError).forEach(key => {
                        setError(key, { message: validationError[key] });
                    });
                });
            }
        }

        setLoading(false);
    };

    return (
        <AppModal
            size="lg"
            show={show}
            onHide={handleModalClose}
            backdrop="static"
            modalTitle="Edit Partner">
            <div className="formView">
                <form
                    className="row g-2"
                    onSubmit={handleSubmit(handleCreatePartner)}>
                    {message && message.type && (
                        <MessageContainer message={message} />
                    )}
                    <div className="col-md-6">
                        <label htmlFor="PartnerName">Partner Name</label>
                        <input
                            type="text"
                            className={
                                errors?.name
                                    ? 'form-control is-invalid'
                                    : 'form-control'
                            }
                            id="PartnerName"
                            placeholder="Enter partner name"
                            {...register('name', {
                                required: true,
                                maxLength: {
                                    value: 200,
                                    message:
                                        'Partner name can be max. 200 char length',
                                },
                            })}
                        />
                        {errors && (
                            <div className="invalid-feedback">
                                {errors.name?.message.replace('', '')}
                            </div>
                        )}
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="LastName">Contact Person Name</label>
                        <input
                            type="text"
                            className={
                                errors?.contact_name
                                    ? 'form-control is-invalid'
                                    : 'form-control'
                            }
                            id="LastName"
                            placeholder="Enter contact name"
                            {...register('contact_name', {
                                required: true,
                                maxLength: {
                                    value: 200,
                                    message:
                                        'Contact name can be max. 200 char length',
                                },
                            })}
                        />
                        {errors && (
                            <div className="invalid-feedback">
                                {errors.contact_name?.message.replace('', '')}
                            </div>
                        )}
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="Email">Contact Email</label>
                        <input
                            type="text"
                            className={
                                errors?.contact_email
                                    ? 'form-control is-invalid'
                                    : 'form-control'
                            }
                            id="Email"
                            placeholder="Enter email"
                            {...register('contact_email', { required: true })}
                        />
                        {errors && (
                            <div className="invalid-feedback">
                                {errors.contact_email?.message.replace('', '')}
                            </div>
                        )}
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="SubDomain">Subdomain</label>
                        <input
                            type="text"
                            className={
                                errors?.subdomain
                                    ? 'form-control is-invalid'
                                    : 'form-control'
                            }
                            id="SubDomain"
                            disabled
                            placeholder="Enter subdomain "
                            {...register('subdomain', {
                                required: true,
                                maxLength: {
                                    value: 200,
                                    message:
                                        'subdomain name can be max. 50 char length',
                                },
                            })}
                        />
                        {errors && (
                            <div className="invalid-feedback">
                                {errors.subdomain?.message.replace('', '')}
                            </div>
                        )}
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="mobile">Contact Mobile Number</label>
                        <PhoneInputWithCountry
                            name="contact_number"
                            countries={['US']}
                            control={control}
                            defaultCountry="US"
                            placeholder="Enter phone number"
                            rules={{
                                required: true,
                                validate: isPossiblePhoneNumber,
                            }}
                            className={
                                errors?.contact_number
                                    ? 'form-control is-invalid'
                                    : 'phone-number'
                            }
                        />
                        {errors && (
                            <div className="invalid-feedback">
                                {errors.contact_number?.message.replace('', '')}
                            </div>
                        )}
                    </div>
                    <div className="col-md-12">
                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={loading}>
                            {loading && (
                                <span className="spinner-border spinner-border-sm"></span>
                            )}
                            Submit
                        </button>
                    </div>
                </form>
            </div>
        </AppModal>
    );
};

export default WithLogin(EditPartner);
